import { Component } from "@angular/core";
import { AppResource } from "@app/app.resource";
import { Resource } from "@app/resources/resource";

@Component({
  selector: "app-base",
  template: "",
  standalone: true,
  providers: [],
})
export abstract class BaseComponent {
  public resource!: Resource;


  public isBranchMRH = false;
  public isBranchPJ = false;
  public isBranchSA = false;
  
  constructor(protected readonly resources: AppResource) {
    this.resource = resources["resource"];
  }

}

